import { lazy } from '@loadable/component';

const FerryFlow = lazy(() =>
  import(
    /* webpackChunkName: "ferry_flow" */
    './ferry_flow'
  )
);

export default FerryFlow;
